import Alpine from 'alpinejs';
import focus from '@alpinejs/focus'
import { register } from 'swiper/element/bundle';
register();
import Cookies from "js-cookie";
import { Breakpoints } from "../breakpoints.js";
// import favourites from './snippets/favourites.js';
import ShyListener from './modules/ShyListener.js';
import { slideDown, slideToggle, slideUp, slideToggleDefaults } from './snippets/slide-toggle-container.js';
import { createFocusTrap } from 'focus-trap';
import $money from './modules/alpine-money.js';
import resize from '@alpinejs/resize';

window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(resize);

$money();

window.Cookies = Cookies;

window.setSectionTabindex = (el, to = "-1") => {
  [...(el instanceof NodeList
    ? el
    : el.querySelectorAll('a, input, button'))
    ].forEach((item) => {
    item.setAttribute("tabindex", to);
  });
};
// window.setSectionTabindexes = (items, to = "-1") => {
//   items.filter(i => ['a','input','button'].indexOf(String(i.nodeName).toLowerCase()) != -1).forEach((item) => {
//     item.setAttribute("tabindex", to);
//   });
// };

window.slideToggle = (el, opts = {}) => {
  slideToggle(el, { ...slideToggleDefaults, ...opts });
};
window.slideUp = (el, opts = {}) => {
  slideUp(el, { ...slideToggleDefaults, ...opts });
};;
window.slideDown = (el, opts = {}) => {
  slideDown(el, { ...slideToggleDefaults, ...opts });
};
window.createFocusTrap = (el, opts = {}) => createFocusTrap(el, opts);

window.Breakpoints = Breakpoints;

Alpine.store('geniusTips', []);
Alpine.store('cartOpen', false);
Alpine.store('mobileMenuOpen', false);
Alpine.store('filtersOpen', false);

document.addEventListener("DOMContentLoaded", () => {
  window.shyListener = new ShyListener();

  // Gorgias chat open
  document.querySelectorAll('[href="#open-gorgias"]').forEach((el) => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      GorgiasChat?.open();
    });
  });
});

// NOTE: Alpine.start() runs at end of page, in case new components.
